import { render, staticRenderFns } from "./ApplicationGrading.vue?vue&type=template&id=b6a2d1ea&scoped=true&"
import script from "./ApplicationGrading.vue?vue&type=script&lang=js&"
export * from "./ApplicationGrading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a2d1ea",
  null
  
)

export default component.exports